import React, { useState, useEffect, useRef } from "react";
import { auth } from '../../Components/FirebaseComp/firebase';
import { Link, useNavigate } from 'react-router-dom';
import './nav.css';
import { FaUserCircle, FaCaretDown } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faFile, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

const NavComp = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false); // FIXED
  const [dropdownOpen, setDropdownOpen] = useState(null); // FIXED

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setIsLoggedIn(false);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleDropdown = (menu) => {
    setDropdownOpen(dropdownOpen === menu ? null : menu);
  };

  const handleDropdownClick = (event) => {
    if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  const toggleMobileMenu = () => { // FIXED
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeAllMenus = () => { // FIXED
    setMobileMenuOpen(false);
    setDropdownOpen(null);
    setShowDropdown(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-header">
          <Link to="/" className="logo" onClick={closeAllMenus}>
            <img src="/logo192.png" alt="Asian Polytechnic Campus" />
            <div className="logo-text">
              <span className="logo-main">ASIAN POLYTECHNIC</span>
              <span className="logo-sub">CAMPUS</span>
            </div>
          </Link>

          <button
            className="mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation"
          >
            <span className={`hamburger ${mobileMenuOpen ? 'open' : ''}`}></span>
          </button>
        </div>

        <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item"><Link to="/" onClick={closeAllMenus}>Home</Link></li>

            {/* About Dropdown */}
            <li
              className={`nav-item dropdown ${dropdownOpen === 'about' ? 'open' : ''}`}
              onMouseEnter={() => setDropdownOpen('about')}
              onMouseLeave={() => setDropdownOpen(null)}
            >
              <span onClick={() => toggleDropdown('about')}>About <i className="dropdown-arrow">▼</i></span>
              <div className="dropdown-menu">
                <Link to="/aboutus" onClick={closeAllMenus}>About APC</Link>
              </div>
            </li>

            {/* Academics Dropdown */}
            <li
              className={`nav-item dropdown ${dropdownOpen === 'academics' ? 'open' : ''}`}
              onMouseEnter={() => setDropdownOpen('academics')}
              onMouseLeave={() => setDropdownOpen(null)}
            >
              <span onClick={() => toggleDropdown('academics')}>Our Courses <i className="dropdown-arrow">▼</i></span>
              <div className="dropdown-menu">
                <Link to="/it-course" onClick={closeAllMenus}>Information Technology</Link>
                <Link to="/english-course" onClick={closeAllMenus}>English</Link>
                <Link to="/pharmacology-course" onClick={closeAllMenus}>Pharmacology</Link>
                <Link to="/audiology-course" onClick={closeAllMenus}>Audiology</Link>
              </div>
            </li>

            <li className="nav-item"><Link to="/admission" onClick={closeAllMenus}>Admissions</Link></li>
            <li className="nav-item"><Link to="/contactus" onClick={closeAllMenus}>Contact Us</Link></li>

            {/* <li className="nav-item nav-cta">
              <Link to="/apply" className="apply-button-nav outline" onClick={closeAllMenus}>Apply Now</Link>
            </li> */}

            {!isLoggedIn && (
              <li className="auth-buttons">
                <Link to="/signin">
                  <button className="navbar-btn-login" onClick={closeAllMenus}>SIGN IN</button>
                </Link>
                <Link to="/signup">
                  <button className="navbar-btn-login" onClick={closeAllMenus}>SIGN UP</button>
                </Link>
              </li>
            )}
          </ul>

          <div className="navbar-buttons">
            {isLoggedIn && (
              <div className="user-menu-container">
                <button className="user-icon" onClick={() => setShowDropdown(!showDropdown)}>
                  <FaUserCircle size={24} /> <FaCaretDown size={16} />
                </button>
                {showDropdown && (
                  <ul className="user-dropdown" ref={dropdownRef}>
                    <li>
                      <Link to="/userprofile" onClick={handleDropdownClick}>
                        <FontAwesomeIcon icon={faUser} className="me-2" /> My Profile
                      </Link>
                    </li>
                    
                    {/* <li>
                      <Link to="/viewapplication" onClick={handleDropdownClick}>
                        <FontAwesomeIcon icon={faFile} className="me-2" /> View My All Payments
                      </Link>
                    </li>
                    <li>
                      <Link to="/viewpayment" onClick={handleDropdownClick}>
                        <FontAwesomeIcon icon={faFile} className="me-2" /> Download My Payment Slips
                      </Link>
                    </li> */}
                    <li>
                      <button onClick={(e) => { handleLogout(); handleDropdownClick(e); }}>
                        <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Log Out
                      </button>
                    </li>
                  </ul>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavComp;
